// extracted by mini-css-extract-plugin
module.exports = {"list":"price_list_1rx8v","card":"price_card_R70CM","sdhat":"price_sdhat_1YHFK","img":"price_img_3rhm5","w":"price_w_3vg8X","img1":"price_img1_3a9kY"};